<template>
  <div>
    <el-row>
      <div class="common-form">服务类型</div>
      <el-form-item label="服务类型">
        <el-select size="small" v-model="form.waiter.serviceId" placeholder="服务类型">
          <!-- <el-option label="全部" value="0"></el-option> -->
          <el-option v-for="(item, index) in form.service_type" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-row>
    <el-row>
      <div class="common-form">服务项目</div>
      <div v-if="form.product_list&&form.product_list.length>0">
        <el-checkbox-group v-model="checkedProducts" @change="change">
          <el-col :span="6" v-for="(item, index) in form.product_list" :key="index" style="flex: 0 0 25%;">
            <div class="checkbox-group">
              <el-checkbox :label="item.product_id">
                <!-- <el-checkbox :label="item.product_id"> -->
                <div class="content_box">
                  <div style="flex:1; justify-content: center;">
                    <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ item.productName }}
                    </div>
                    <div style="color:orange;margin:5px 0">
                      价格：￥{{ item.productPrice }}
                    </div>
                    <el-tag type="success" size="medium" v-if="item.isClock==1">加钟</el-tag>
                  </div>
                  <img style="margin-left:10px" :src="item.image" width="80" height="80" />
                </div>
              </el-checkbox>
            </div>
          </el-col>
        </el-checkbox-group>
      </div>
      <div v-else style="width:100%;margin:30px 0;display:flex;justify-content: center;">-- 暂无项目 --</div>
    </el-row>
  </div>
</template>

<script>
export default {
  inject: ["form"],
  data() {
    return {
      checkedProducts: [],
      checkedProductsArray: []
    };
  },
  mounted() {
    // 初始化时将item.selected == '2'的项目设置为默认选中
    if( this.form.product_list){
 this.form.product_list.forEach(item => {
      if (item.selected == "2") {
        this.checkedProducts.push(item.product_id);
        this.checkedProductsArray.push(item.product_id);
      }
    });
    }
   
  },
  methods: {
    change(checkedItems) {
      this.checkedProducts = checkedItems;
      this.form.product_newselected = checkedItems;
      console.log("选中的产品ID数组:", this.form.product_newselected);
    }
  }
};
</script>

<style scoped>
.checkbox-group {
  display: flex;
  font-size: 18px;
  padding: 10px;
  align-items: center;
  border-radius: 10px;
  background-color: #dcdfe6;
  margin: 20px 10px;
}

.content_box {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/technicianlist/part/project.vue